import store from '@/store/index'

export default {}

/**
 * Returns the full state object for the specified module.
 *
 * @param module String
 *
 * @returns Object
 */
export const get = (module) => {
  return store.getters[`${module}/get`]
}

/**
 * Returns an array of locations for the specified module.
 *
 * @param module String
 *
 * @returns Array
 */
export const locations = (module) => {
  return store.getters[`${module}/locations`]
}

/**
 * Returns the number of locations.
 *
 * @param module String
 *
 * @returns Number
 */
export const locationsCount = (module) => {
  return store.getters[`${module}/locations`].length
}

/**
 * Finds and returns a location by id or undefined if not found.
 *
 * @param module String
 * @param id     Number
 *
 * @returns Array
 */
export const locationById = (module, id) => {
  return store.getters[`${module}/locations`].find(
    location => location.id === id
  )
}

/**
 * Finds and returns a location by index or undefined if not found.
 *
 * @param module String
 * @param index  Number
 *
 * @returns Array
 */
export const locationByIndex = (module, index) => {
  let locations = store.getters[`${module}/locations`]
  if (index < locations.length) {
    return locations[index]
  } else {
    return undefined
  }
}

/**
 * Returns the current form warning.
 *
 * @param module String
 *
 * @return string
 */
export const warning = (module) => {
  return store.getters[`${module}/warning`]
}

/**
 * Returns the newest (last) location in the list of locations.
 *
 * @param module String
 *
 * @returns Object
 */
export const newest = (module) => {
  return locations[store.getters[`${module}/get`].length - 1]
}

/**
 * Returns the location types.
 *
 * @param module String
 *
 * @returns Object
 */
export const locationTypes = (module) => {
  return store.getters[`${module}/locationTypes`]
}

/**
 * API request to create a new location. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const post = (module, payload) => {
  return store.dispatch(`${module}/post`, payload)
}

/**
 * API request to update an existing location. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const put = (module, payload) => {
  return store.dispatch(`${module}/put`, payload)
}

/**
 * API request to delete an existing location. The payload must be in the format:
 * { url: String, data: Object }
 *
 * @param module  String
 * @param payload Object
 */
export const deleteLocation = (module, payload) => {
  return store.dispatch(`${module}/delete`, payload)
}

/**
 * Set an array of locations.
 *
 * @param module   String
 * @param locations Array
 */
export const setLocations = (module, locations) => {
  store.commit(`${module}/setLocations`, locations)
}

/**
 * Set the location types.
 *
 * @param module       String
 * @param locationTypes Object
 */
export const setLocationTypes = (module, locationTypes) => {
  store.commit(`${module}/setLocationTypes`, locationTypes)
}

/**
 * Add a new location.
 *
 * @param module  String
 * @param location Object
 */
export const add = (module, location) => {
  store.commit(`${module}/add`, location)
}

/**
 * Updates an existing location.
 *
 * @param module  String
 * @param location Object
 */
export const update = (module, location) => {
  store.commit(`${module}/update`, location)
}

/**
 * Find a location by index in the array of locations and updates it.
 *
 * @param module  String
 * @param location Object
 * @param index   Number
 */
export const updateByIndex = (module, location, index) => {
  store.commit(`${module}/updateByIndex`, { location, index })
}

/**
 * Updates the last location that was added.
 *
 * @param module  String
 * @param location Object
 */
export const updateNewest = (module, location) => {
  store.commit(`${module}/updateNewest`, location)
}

/**
 * Find a location by id and remove it.
 *
 * @param module  String
 * @param id      Number
 */
export const removeById = (module, id) => {
  store.commit(`${module}/removeById`, id)
}

/**
 * Find a location by id and remove it.
 *
 * @param module  String
 * @param index   Number
 */
export const removeByIndex = (module, index) => {
  store.commit(`${module}/removeByIndex`, index)
}

/**
 * Clears both the locations and location types from the state.
 *
 * @param module String
 */
export const purge = (module) => {
  store.commit(`${module}/purge`)
}

/**
 * Purge the locations only and not the location types.
 *
 * @param module String
 */
export const purgeLocations = (module) => {
  store.commit(`${module}/purgeLocations`)
}

/**
 * Sets the isAdding form state.
 *
 * @param module   String
 * @param isAdding Boolean
 */
export const setIsAdding = (module, isAdding) => {
  store.commit(`${module}/setIsAdding`, isAdding)
}

/**
 * Sets the isEditing form state.
 *
 * @param module   String
 * @param isEditing Boolean
 */
export const setIsEditing = (module, isEditing) => {
  store.commit(`${module}/setIsEditing`, isEditing)
}

/**
 * Sets the isDeleting form state.
 *
 * @param module   String
 * @param isDeleting Boolean
 */
export const setIsDeleting = (module, isDeleting) => {
  store.commit(`${module}/setIsDeleting`, isDeleting)
}

/**
 * Sets the form warning.
 *
 * @param module  String
 * @param warning String
 */
export const setWarning = (module, warning) => {
  store.commit(`${module}/setWarning`, warning)
}

/**
 * Resets the form state.
 *
 * @param module   String
 */
export const resetFormState = (module) => {
  store.commit(`${module}/resetFormState`)
}



// WEBPACK FOOTER //
// ./src/store/locations/locations.helpers.js